import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ValidationResult } from '../../../models/projects/validation.models';
import { FieldPositioningEditor } from '../../../models/field-positioning/field-positioning.models';
import { AppConfig } from '../../../app/app.config';

/**
 * Generated class for the FieldPositioningCompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-field-positioning-complete',
  templateUrl: 'field-positioning-complete.html',
})
export class FieldPositioningCompletePage {
  config = AppConfig.settings;

  loading: boolean;
  editor: FieldPositioningEditor;
  validationResult: ValidationResult;
  callback: Function;
  notes: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.ionViewEnter();
  }

  async ionViewEnter() {
    this.editor = this.navParams.get('activity');
    this.validationResult = this.navParams.get('validation');
    this.callback = this.navParams.get('callback');
    this.loading = false;
  }

  async cancel() {
    this.callback(this.editor, true).then(() => {
      this.navCtrl.pop();
    });
  }

  async confirm() {
    this.editor.completionNotes = this.notes;
    this.callback(this.editor, false).then(() => {
      this.navCtrl.pop();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/field-positioning/field-positioning-complete/field-positioning-complete.ts